import { render, staticRenderFns } from "./AddAnnouncement.vue?vue&type=template&id=5a635026"
import script from "./AddAnnouncement.vue?vue&type=script&lang=js"
export * from "./AddAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports